import { useQuery } from "react-query";
import { getTerms } from "../components/Api/Getters";

export const useTermsQuery = (token) => {
	const queryOptions = {
		refetchOnWindowFocus: false,
		staleTime: 1000 * 5,
		enabled: !!token,
	};
	return useQuery(
		"termsList",
		async () => {
			const terms = await getTerms(token);
			const termArray = [];
			if (terms.length > 0) {
				terms.forEach((term) => {
					termArray.push(term.term);
				});
			}

			//sort term array on term ascending
			termArray.sort((a, b) => {
				return b - a;
			});

			return termArray;
		},
		queryOptions
	);
};

export const useTermsQueryFull = (token) => {
	const queryOptions = {
		refetchOnWindowFocus: false,
		staleTime: 1000 * 5,
		enabled: !!token,
	};
	return useQuery(
		"termsObjects",
		async () => {
			const terms = await getTerms(token);
			const termArray = [];
			if (terms.length > 0) {
				terms.forEach((term) => {
					let termObj = {
						name: term.desc_term + "(" + term.term + ")",
						term: term.term,
						desc: term.desc_term,
						start: term.s_date,
						end: term.e_date,
						active: term.active,
					};
					termArray.push(termObj);
				});
			}

			//sort term array on term.term ascending
			termArray.sort((a, b) => {
				return b.term - a.term;
			});

			return termArray;
		},
		queryOptions
	);
};
